export const USER_ROLE_OPTIONS = [
  {
    label: 'administrator',
    value: 'administrator',
  },
  {
    label: 'staff',
    value: 'staff',
  },
  {
    label: 'social_worker',
    value: 'social_worker',
  },
];

export const FOSTER_FAMILY_RANK_OPTIONS = [
  {
    label: 'family_home',
    value: 'family_home',
  },
  {
    label: 'reinforced_family_home',
    value: 'reinforced_family_home',
  },
  {
    label: 'extra_reinforced_family_home',
    value: 'extra_reinforced_family_home',
  },
  {
    label: 'nursing_home',
    value: 'nursing_home',
  },
  {
    label: 'treatment_family',
    value: 'treatment_family',
  },
  {
    label: 'support_nearby_living',
    value: 'support_nearby_living',
  },
];

export const FOSTER_FAMILY_STATUS_OPTIONS = [
  {
    label: 'ready',
    value: 'ready',
  },
  {
    label: 'pending',
    value: 'pending',
  },
  {
    label: 'full',
    value: 'full',
  },
  {
    label: 'inactivated',
    value: 'inactivated',
  },
];

export const GENDER_OPTIONS = [
  { label: 'male', value: 'male' },
  { label: 'female', value: 'female' },
  { label: 'unknown', value: 'unknown' },
];

export const SEARCH_BOOL_OPTIONS = [
  { label: 'yes', value: 'yes' },
  { label: 'no', value: 'no' },
  { label: 'all', value: 'all' },
];
